<template>
  <div class="home">
    <!-- swiper Area start -->
    <div class="swiper-container" style="margin-top: 10px;">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div id="home" class="hero-area" style="padding-top: 0;">
            <div class="swiper-slide video-slide">
              <div class="hero-area">
                <video 
                  id="homeVideoDesktop" 
                  autoplay 
                  loop 
                  muted 
                  preload="metadata" 
                  poster="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/banner02.png"
                  style="width: 100%; height: 100%; object-fit: cover;">
                  <source src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/video/anovator_v2-banner.mp4" type="video/mp4">
                </video>
              </div>
            </div>
          </div>
        </div>
        
         <div class="swiper-slide" style="cursor: pointer;">
          <div class="main-img">
            <picture>
              <img src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/banner-all.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/banner-allx2.png" alt="">
            </picture>
          </div>
        </div>

        <!-- <div class="swiper-slide" style="cursor: pointer;">
          <div class="main-img">
            <picture>
              <img src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/banner-a5.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/banner-a5x2.png" alt="">
            </picture>
          </div>
        </div> -->

      </div>
      <div class="swiper-pagination"></div>
      <div class="scroll-mouse">
        <img style="width: 30px;height: 30px;" src="static/images/mouse-w.png"/>
        <p style="color: #FFFFFF;font-size: 12px;margin-top: 10px;">Scroll Mouse</p>
      </div>
    </div>
    <!-- swiper Area end -->

    <!-- Hero Area start -->
    <section class="hot-features-area" id="mobileSlide">
      <div>
        <video 
          id="homeVideoMobile" 
          controls 
          loop 
          muted 
          preload="metadata" 
          poster="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/banner.jpg"
        >
          <source src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/video/banner.mp4" type="video/mp4">
        </video>
      </div>
    </section>
    <!-- Hero Area End -->
    
    <!-- features Area start -->
    <section class="hot-features-area" style="padding:0;">
      <div class="electrode-bg">
        <img src="/static/images/textures.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/textures2x.png" alt="" ref="lazyImg">
      </div>
      <div class="container electrode-title-box">
        <div class="section-header-2 animated fadeInDown" style="text-align: left;" data-wow-offset="10" data-wow-duration="1.5s">
          <div class="section-description">
            <p class="features-title">
              <span>How Does <span style="font-weight: 600;">ANOVATOR</span> evaluate People's Health</span>
            </p>
          </div>
          <p style="font-weight: 100;">
            We are committed to improving people's health and helping people understand their bodies better.
          </p>
        </div>
      </div>
      
      <!-- 电极测量部分 -->
      <ElectrodeMeasurement />
      
      <!-- AI姿态分析部分 -->
      <AIPostureAnalysis />
      
      <!-- 产品展示部分 -->
      <ProductShowcase />
    </section>
    <!-- features Area end -->
  </div>
</template>

<script>
import ElectrodeMeasurement from '../components/ElectrodeMeasurement.vue'
import AIPostureAnalysis from '../components/AIPostureAnalysis.vue'
import ProductShowcase from '../components/ProductShowcase.vue'
import { lazyLoadingMixin } from '@/mixins/lazyLoading'

export default {
  name: 'Home',
  mixins: [lazyLoadingMixin],
  components: {
    ElectrodeMeasurement,
    AIPostureAnalysis,
    ProductShowcase
  },
  mounted() {
    // 设置页面标题
    document.title = 'ANOVATOR | Smart Body Composition Analyzer'
    this.initSwiper()
    this.initClickEvents()
    this.initScrollListener()
  },
  methods: {
    initSwiper() {
      this.$nextTick(() => {
        if (window.Swiper) {
          new window.Swiper('.swiper-container', {
            loop: true,
            autoplay: {
              delay: 20000,
              disableOnInteraction: false,
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            }
          })
        }
      })
    },
    initClickEvents() {
      // Vue实现的点击事件处理
      this.$nextTick(() => {
        const btnMoreElements = document.querySelectorAll('.btn-more')
        btnMoreElements.forEach(btn => {
          btn.addEventListener('click', (e) => {
            const path = e.target.getAttribute('data-path')
            if (path) {
              window.open(path)
            }
          })
        })
      })
    },
    initScrollListener() {
      const scrollMouseElement = document.querySelector('.scroll-mouse')
      if (scrollMouseElement) {
        window.addEventListener('scroll', () => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop
          if (scrollTop > 100) {
            scrollMouseElement.style.display = 'none'
          }
        })
      }
    }
  }
}
</script>

<style scoped>
/* 组件特定样式 */
</style>